import {filter, lazy} from './lang.js';

export const fetchMelody = (trackNumber) => {
    return (...args) => {
        let _trackNumber = lazy(trackNumber, ...args);

        if (!args[3]) {
            return [0];
        }
        let subSequence = args[3].track.subSequence;
        let track = subSequence.tracks[_trackNumber % subSequence.tracks.length];
        let {pattern} = track;
        let transposes = [];
        for (let stepNumber in pattern.stepBucketsMatrix) {
            let bucket = pattern.stepBucketsMatrix[stepNumber];
            for (let pos in bucket.steps) {
                transposes = [
                    ... transposes,
                    ... bucket.steps[pos]
                        .getPolyphony().map(x => x.transpose)
                ];
            }
        }
        return transposes;
    };
};
